import { Form, Input } from "decorator-form";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as displayFragments from "./displayFragments"
import InputType from "common/form/InputType";
import * as actionFragments from "./actionFragments"

const layout = FragmentProvider.getLayoutInput({...displayFragments,  ...actionFragments});

@Form({title: "Course Details"})
export default class CESelfReportFormPanelConfig {

	@Input({type: layout, title: "Layout"})
	public layout: ILayout<IFragmentLayoutConfig>;

	@Input({type:InputType.TEXT, title:"Credit List"})
	public creditList: string

	@Input({type: InputType.TEXT, title:"Redirect URL"})
	public redireURL: string= "/mylearning/completions";
	
	@Input({ type: InputType.NUMBER, title: "Credit Step" })
    public creditStep: number;

}



// WEBPACK FOOTER //
// ./src/panels/addExternalCredit/CESelfReportFormConfig.ts